<template>
  <div class="container">
      <el-row>
        <el-col :span="8">&nbsp;</el-col>
          <el-col :span="8">
            <img src="../assets/404.png" class="nologpng"/>
          </el-col>
          <el-col :span="8">&nbsp;</el-col>
      </el-row>

      <el-row>
          <el-col :span="8">&nbsp;</el-col>
          <el-col :span="8">
            <h2>非法进入！未通过身份验证，请从已登录的合同管理系统进行跳转。</h2><br/>
            <el-button type="primary" size="mini" @click="exit" icon="el-icon-s-promotion">离开</el-button>
          </el-col>
          <el-col :span="8">&nbsp;</el-col>
        </el-row>
  </div>
</template>

<script>
export default {
    name:'Nolog',
    methods:{ 
        exit(){
            window.close()
            this.$router.replace('/login')
        }
    }
}
</script>

<style scoped>
    .container{ 
        width: 100%;
        height: 500px;
        margin-top: 150px;
    }
    .nologpng{
        width: 100%;
        height: 300px;
    }
</style>